import React from "react";

import CustomAvatar from "components/common/Avatar";
import CustomChip from "components/common/Chip";

import { baseUrl } from "util/APIBaseUrl";

import "./UniversalSearchResult.scss";

export type UniversalSearchResultType = "talent" | "customerUser" | "customer";

export type UniversalSearchResultItem = {
  resultType: UniversalSearchResultType;
  id: string;
  name: string;
  email?: string | null;
  customerId?: string | null;
  companyName?: string | null;
  picturePath?: string | null;
  pictureVersion?: string | null;
};

type UniversalSearchResultProps = {
  result: UniversalSearchResultItem;
  onSelect: (result: UniversalSearchResultItem) => void;
};

const CHIP_BY_TYPE: Record<UniversalSearchResultType, { label: string; color: string }> = {
  talent: { label: "Talent", color: "success" },
  customerUser: { label: "Customer user", color: "primary" },
  customer: { label: "Customer", color: "warning" },
};

const LOGO_PATH_BY_TYPE: Record<UniversalSearchResultType, string> = {
  talent: "employee",
  customerUser: "customerUser",
  customer: "customer",
};

const getInitials = (name: string) =>
  (name || "")
    .split(" ")
    .filter(Boolean)
    .slice(0, 2)
    .map((part) => part[0].toUpperCase())
    .join("");

const getImageSource = (result: UniversalSearchResultItem) => {
  if (!result.picturePath) return "";
  return `${baseUrl}/${LOGO_PATH_BY_TYPE[result.resultType]}/${result.id}/logo?id=${result.pictureVersion}`;
};

function UniversalSearchResult({ result, onSelect }: UniversalSearchResultProps) {
  const chip = CHIP_BY_TYPE[result.resultType];

  return (
    <button
      type="button"
      className="universal-search-result"
      onClick={() => onSelect(result)}
      aria-label={result.name}
    >
      <CustomAvatar
        alt={result.name}
        src={getImageSource(result)}
        size="md"
        variant={result.resultType === "customer" ? "rounded" : "circular"}
      >
        {getInitials(result.name)}
      </CustomAvatar>

      <span className="universal-search-result__body">
        <span className="universal-search-result__name para-body-m-medium">{result.name}</span>
        {result.email ? (
          <span className="universal-search-result__email para-body-s-regular">{result.email}</span>
        ) : null}
      </span>

      <CustomChip
        className="universal-search-result__chip"
        label={chip.label}
        labelClass="para-body-xs-medium"
        color={chip.color}
        variant="filled"
        size="small"
      />
    </button>
  );
}

export default UniversalSearchResult;
